module.exports = __webpack_public_path__ + "static/images/technology_1_2.419495b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_2.png
// module id = bF4l
// module chunks = 8